import { Stack, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { IncomeReportCardItemProps } from './types';

export function IncomeReportCardItem({
  title,
  value,
}: IncomeReportCardItemProps) {
  return (
    <Stack
      justifyContent="flex-start"
      flexBasis="calc(33.333% - 16px)"
      minWidth={321}
      mb={2}
    >
      <Typography
        variant="text"
        fontWeight={600}
        color={NEW_COLORS.PRIMARY[400]}
      >
        {title}
      </Typography>
      <Typography
        variant="subtitle1"
        fontWeight={400}
        color={NEW_COLORS.GRAYSCALE[700]}
      >
        {value}
      </Typography>
    </Stack>
  );
}
